export default "__VITE_ASSET__Defa5d6E__"